import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MetaService} from '../../../services/meta/meta.service';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {LangTgtService} from '../../../services/lang-tgt/lang-tgt.service';
import {AssessmentService} from '../../../services/assessment/assessment.service';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';

@Component({
  selector: 'app-assessment-state',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    SpinnerComponent
  ],
  templateUrl: './assessment-state.component.html',
  styleUrls: ['./assessment-state.component.scss']
})
export class AssessmentStateComponent implements OnInit {

  loading = true;
  state: any;
  deadline: Date | null = null;

  constructor(
    private metaSrv: MetaService,
    private translate: TranslateService,
    public langSrcSrv: LangSrcService,
    private langTgtSrv: LangTgtService,
    private router: Router,
    private assessmentSrv: AssessmentService
  ) {
  }

  trackByIndex(index: number) { return index; }

  async ngOnInit() {
    this.translate.get(`Test de fin de formation`).subscribe((value: string) => {
      this.metaSrv.setMetas({title: value});
    });
    this.state = await this.assessmentSrv.state();
    // Le test n'existe pas pour cette langue : retour au tableau de bord
    if (!this.state) {
      await this.close();
      return;
    }
    this.deadline = await this.assessmentSrv.getTrainingEndDate(this.langTgtSrv.current.code);
    this.loading = false;
  }

  async close() {
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'learning', 'dashboard']);
  }

  async start() {
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'assessment', 'questions']);
  }

  async viewResult() {
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'assessment', 'result']);
  }

  formatPlayTime(seconds: number): string {
    const minutes = Math.round((seconds || 0) / 60);
    return `${minutes} min`;
  }

}
